const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const streamAI = async (path, body, onToken) => {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok || !res.body) {
    const err = await res.json().catch(() => ({}));
    throw new Error(typeof err?.detail === "string" ? err.detail : "Servizio AI non disponibile.");
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  let full = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const msg = JSON.parse(p.slice(6));
      if (msg.error) throw new Error(msg.error);
      if (msg.t) { full += msg.t; onToken(full); }
    }
  }
  return full;
};

const TAG = /\[\[SERVIZI:([^\]]*)\]\]/;
export const parseSuggestions = (text = "") => {
  const m = text.match(TAG);
  const ids = m ? m[1].split(",").map((s) => s.trim()).filter(Boolean) : [];
  return { clean: text.replace(TAG, "").replace(/\[\[SERVIZI:[^\]]*$/, "").trim(), ids };
};

export const getSessionId = () => {
  let id = localStorage.getItem("mm_chat_session");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("mm_chat_session", id);
  }
  return id;
};
